<p-toast [baseZIndex]="9999" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" #myForm autocomplete="off">
      <div class="row">
        <div class="col-4">
          <lib-page-header page-title="AUDITORIA DO SISTEMA"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/portfolio.png">
          </lib-page-header>
        </div>
        <div class="col-8">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a routerLink="/auditoria" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="col-12">
          <div class="form-row mb-2">
            <div class="col-12">
              <h4 *ngIf="entidade.operacao === 'R'" class="text-danger">REMOÇÃO</h4>
              <h4 *ngIf="entidade.operacao === 'I'" class="text-primary">INSERÇÃO</h4>
              <h4 *ngIf="entidade.operacao === 'A'" class="text-warning">ALTERAÇÃO</h4>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <span><i class="fa fa-user" style="font-size: 18px;margin-right: 5px;"></i>
                Responsavel: {{entidade.usuario?.nome != null ? entidade.usuario.nome : 'Não Informado'}}</span>
              <span class="ml-4"><i class="fa fa-calendar" style="font-size: 18px;margin-right: 5px;"></i>
                Data Alteração: {{entidade.data_cadastro | date:'dd/MM/yyyy':'GMT'}}</span>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-4" />
      <div class="form-row">
        <div class="col-md-4">
          <p-tree selectionMode="single" [filter]="true" [value]="arvore_alteracoes"
            [(selection)]="selectGalho" (onNodeSelect)="nodeSelectEvent($event)"></p-tree>
        </div>
        <div class="col-md-8 p-3">
          <div *ngIf="selectGalho" class="form-row">
            <div *ngFor="let item of selectGalho.children" class="col-12">
              <div class="form-row mb-2">
                <div class="col-12">
                  <span><i class="fa fa-database"
                      style="font-size: 18px; margin-right: 10px; color: #49688e;"></i>{{item.label}}</span>
                </div>
              </div>
              <div class="form-row">
                <div class="col-5" style="line-height: 30px;">
                  <p style="word-wrap: break-word;"> Antes: {{item.data.antes !== null
                    ? (item.children.length ? item.label : item.data.antes) : 'Vazio'}}</p>
                </div>
                <div class="col-5" style="line-height: 30px;">
                  <p style="word-wrap: break-word;"> Depois: {{item.data.depois !== null
                    ? (item.children.length ? item.label : item.data.depois) : 'Vazio'}}</p>
                </div>
                <div class="col-2">
                  <button (click)="nodeSelect(item)" class="btn btn-sm btn-outline-secondary mr-2 float-right">
                    <img src="assets/img/global/zoom.png" alt="editar" height="18" width="18">
                  </button>
                </div>
              </div>
              <hr class="mb-1" />
            </div>

            <div *ngIf="!selectGalho.children.length" class="col-12">
              <div class="form-row mb-2">
                <div class="col-12">
                  <span><i class="fa fa-database"
                      style="font-size: 18px; margin-right: 10px; color: #49688e;"></i>{{selectGalho.label}}</span>
                </div>
              </div>
              <div class="form-row">
                <div class="col-6" style="line-height: 30px;">
                  <p style="word-wrap: break-word;">Antes: {{selectGalho.data.antes !== null ? selectGalho.data.antes : 'Vazio'}}</p>
                </div>
                <div class="col-6" style="line-height: 30px;">
                  <p style="word-wrap: break-word;">Depois: {{selectGalho.data.depois !== null ? selectGalho.data.depois : 'Vazio'}}</p>
                </div>
              </div>
              <hr class="mb-1" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>